<template>
	<div class="echarts">
		<v-chart :options="option" />
	</div>
</template>

<script>
	import ECharts from 'vue-echarts'
	import 'echarts/lib/chart/line'
	import 'echarts/lib/component/tooltip'
	import 'echarts/lib/component/legend'
	import 'echarts/lib/component/title'
	export default {
		props: {
			datau: Array,
			colorType: {
				type: Number,
			},
		},
		components: {
			'v-chart': ECharts,
		},
		data() {
			let baseColor = '#fff'
			if (this.colorType == 2) {
				baseColor = '#333'
			}
			return {
				option: {
					// title: {
					//   text: "隐患处理效率分析",
					//   textStyle: {
					//     color: baseColor,
					//   },
					// },
					tooltip: {
						trigger: 'axis',
						textStyle: {
							color: baseColor,
						},
					},
					legend: {
						textStyle: {
							color: baseColor,
						},
					},
					toolbox: {
						show: true,
						feature: {
							dataZoom: {
								yAxisIndex: 'none',
							},
							dataView: { readOnly: false },
							magicType: { type: ['line', 'bar'] },
							restore: {},
							saveAsImage: {},
						},
					},
					grid: {
						left: 40,
						bottom: 60,
						top: 40,
						right: 40,
					},
					color: [
						'#0e9cff',
						'#00bbf1',
						'#f7d868',
						'#21e74b',
						'#e40000',
						'#e77e21',
						'#ce91db',
						'#ade721',
						'#004af1',
						'#f100ee',
					],
					xAxis: {
						type: 'category',
						boundaryGap: false,
						data: [
							'一月',
							'二月',
							'三月',
							'四月',
							'五月',
							'六月',
							'七月',
							'八月',
							'九月',
							'十月',
							'十一月',
							'十二月',
						],
						nameTextStyle: {
							color: baseColor,
						},
						// x轴的字体样式
						axisLabel: {
							show: true,
							textStyle: {
								color: baseColor,
								fontSize: '12',
							},
						},
						//x轴的颜色和宽度
						axisLine: {
							lineStyle: {
								color: baseColor,
							},
						},
					},
					yAxis: {
						type: 'value',
						axisLabel: {
							formatter: '{value}',
						},
						splitLine: {
							show: false,
							//  改变轴线颜色
							lineStyle: {
								// 使用深浅的间隔色
								color: ['red'],
							},
						},
						//y轴的字体样式
						axisLabel: {
							show: true,
							textStyle: {
								color: baseColor,
							},
						},
						//y轴的颜色和宽度
						axisLine: {
							lineStyle: {
								color: baseColor,
								width: 1, //这里是坐标轴的宽度
							},
						},
					},
					series: (() => {
						const list = this.datau
						let newList = []
						for (let item of list) {
							newList.push({
								name: item.name,
								type: 'line',
								data: item.data,
								markPoint: {
									data: [
										{ type: 'max', name: 'Max' },
										{ type: 'min', name: 'Min' },
									],
								},
								markLine: {
									data: [{ type: 'average', name: 'Avg' }],
								},
							})
						}
						console.log(newList)
						return newList
					})(),
					// [
					//   {
					//     name: "燃气行业",
					//     type: "line",
					//     data: [10, 11, 13, 11, 12, 12, 9, 21, 10, 38, 12, 41],
					//     markPoint: {
					//       data: [
					//         { type: "max", name: "Max" },
					//         { type: "min", name: "Min" },
					//       ],
					//     },
					//     markLine: {
					//       data: [{ type: "average", name: "Avg" }],
					//     },
					//   },
					// ],
				},
			}
		},
		mounted() {
			console.log(this.datau)
		},
	}
</script>

<style lang="scss" scoped>
	.echarts {
		height: 96%;
		width: 60vw;
		position: relative;
		top: 4%;
	}
</style>
